import { apiService } from "../api.service";

// Requests

// Domain
import { Service } from "../../models/app/domain";

/**
 * Fetch service-requests Request
 * @return - ServiceRequestsResponse || ErrorResponse
 */
export const fetchServiceRequestsRequest = async () => {
  const response = await apiService.get("/services/requests");
  if (response.hasError) {
    return response;
  }
  return {
    requests: response.data.services.map(service => new Service(service))
  };
};

/**
 * Approve service-requests Request
 * @return - ServiceRequestsResponse || ErrorResponse
 */
export const approveServiceRequest = async (serviceId, branchId) => {
  const response = await apiService.post(
    `/services/requests/${serviceId}/accept`,
    undefined,
    branchId
  );
  if (response.hasError) {
    return response;
  }
  return { message: response.data.message };
};

/**
 * Fetch service  Request
 * @return - ServiceResponse || ErrorResponse
 */
export const fetchServiceDetailsRequest = async (serviceId, branchId) => {
  const response = await apiService.get(`/services/${serviceId}`, branchId);
  if (response.hasError) {
    return response;
  }
  return { service: new Service(response.data.service) };
};

/**
 * Update service-request  Request
 * @return - ServiceResponse || ErrorResponse
 */
export const updateServiceRequest = async (serviceId, payload) => {
  const response = await apiService.patch(
    `/services/requests/${serviceId}`,
    payload
  );
  if (response.hasError) {
    return response;
  }
  return { service: new Service(response.data.service) };
};

/**
 * Fetch available 30-minute slots for a given branch/serviceType/date.
 * @param {{serviceTypeId: number, date: string, excludeServiceId?: number}} params
 * @return - { slots, opening_time, closing_time, closed, closure_reason } || ErrorResponse
 */
export const fetchAvailableSlots = async ({
  serviceTypeId,
  date,
  excludeServiceId
}) => {
  const params = new URLSearchParams({
    service_type_id: String(serviceTypeId),
    date
  });
  if (excludeServiceId !== undefined && excludeServiceId !== null) {
    params.set("exclude_service_id", String(excludeServiceId));
  }
  return apiService.get(`/services/available-slots?${params.toString()}`);
};

/**
 * Decline service-requests Request
 * @return - MessageResponse || ErrorResponse
 */
export const declineServiceRequest = async (
  serviceId,
  declineReasonFormValues,
  branchId
) => {
  const payload = { decline_reason: declineReasonFormValues.declineReason };
  const response = await apiService.post(
    `/services/requests/${serviceId}/decline`,
    payload,
    branchId
  );
  if (response.hasError) {
    return response;
  }
  return { message: response.data.message };
};
